import { render } from "./ManagerDashboard.vue?vue&type=template&id=187025c4&scoped=true"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=187025c4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187025c4"]])

export default __exports__